import {
  CREATE_EDM_DATASET,
  CREATE_EDM_DATASET_FAILED,
  CREATE_EDM_DATASET_SUCCESS,
  GET_EDM_ARTWORK,
  GET_EDM_ARTWORK_FAILED,
  GET_EDM_ARTWORK_SUCCESS,
  GET_EDM_ARTWORKS,
  GET_EDM_ARTWORKS_FAILED,
  GET_EDM_ARTWORKS_SUCCESS,
  GET_EDM_DATASET,
  GET_EDM_DATASET_BLOCKED,
  GET_EDM_DATASET_BLOCKED_FAILED,
  GET_EDM_DATASET_BLOCKED_SUCCESS,
  GET_EDM_DATASET_HANDOFF_PACKAGE,
  GET_EDM_DATASET_HANDOFF_PACKAGE_FAILED,
  GET_EDM_DATASET_HANDOFF_PACKAGE_SUCCESS,
  GET_EDM_POLICY,
  GET_EDM_POLICY_FAILED,
  GET_EDM_POLICY_SUCCESS,
  GET_EDM_DATASET_FAILED,
  GET_EDM_DATASET_SUCCESS,
  GET_EDM_DATASET_SUMMARY,
  GET_EDM_DATASET_SUMMARY_FAILED,
  GET_EDM_DATASET_SUMMARY_SUCCESS,
  GET_EDM_DATASETS,
  GET_EDM_DATASETS_FAILED,
  GET_EDM_DATASETS_SUCCESS,
  RECOMPUTE_EDM_ARTWORK,
  RECOMPUTE_EDM_ARTWORK_FAILED,
  RECOMPUTE_EDM_ARTWORK_SUCCESS,
  RECOMPUTE_EDM_DATASET,
  RECOMPUTE_EDM_DATASET_FAILED,
  RECOMPUTE_EDM_DATASET_SUCCESS,
  TRANSITION_EDM_ARTWORK,
  TRANSITION_EDM_ARTWORK_FAILED,
  TRANSITION_EDM_ARTWORK_SUCCESS,
  UPDATE_EDM_ARTWORK_PROFILE,
  UPDATE_EDM_ARTWORK_PROFILE_FAILED,
  UPDATE_EDM_ARTWORK_PROFILE_SUCCESS,
  UPDATE_EDM_DATASET,
  UPDATE_EDM_DATASET_FAILED,
  UPDATE_EDM_DATASET_SUCCESS,
  VALIDATE_EDM_ARTWORK_MEDIA,
  VALIDATE_EDM_ARTWORK_MEDIA_FAILED,
  VALIDATE_EDM_ARTWORK_MEDIA_SUCCESS,
  VALIDATE_EDM_DATASET_MEDIA,
  VALIDATE_EDM_DATASET_MEDIA_FAILED,
  VALIDATE_EDM_DATASET_MEDIA_SUCCESS,
} from './admin-edm.actions';
import {
  AdminEdmArtworkDetail,
  AdminEdmArtworkSaveErrorDetails,
  AdminEdmArtworkMediaValidationResult,
  AdminEdmArtworkListItem,
  AdminEdmBlockedRecord,
  AdminEdmDatasetDetail,
  AdminEdmDatasetMediaValidationResult,
  AdminEdmDatasetListItem,
  AdminEdmDatasetSummary,
  AdminEdmHandoffPackage,
  AdminEdmPolicy,
} from '../../../../types/adminEdm';
import {
  normalizeAdminEdmArtworkDetail,
  normalizeAdminEdmArtworkListResponse,
  normalizeAdminEdmArtworkMediaValidation,
  normalizeAdminEdmBlockedRecords,
  normalizeAdminEdmDatasetDetail,
  normalizeAdminEdmDatasetListResponse,
  normalizeAdminEdmDatasetMediaValidation,
  normalizeAdminEdmDatasetSummary,
  normalizeAdminEdmHandoffPackage,
} from '../admin-edm.normalizers';

export interface AdminEdmState {
  datasets: AdminEdmDatasetListItem[];
  datasetsTotal: number;
  artworks: AdminEdmArtworkListItem[];
  artworksTotal: number;
  artworksPage: number;
  artworksLimit: number;
  artworkDetail: AdminEdmArtworkDetail | null;
  activeDataset: AdminEdmDatasetDetail | null;
  datasetSummary: AdminEdmDatasetSummary | null;
  datasetBlockedRecords: AdminEdmBlockedRecord[];
  artworkValidation: AdminEdmArtworkMediaValidationResult | null;
  datasetValidation: AdminEdmDatasetMediaValidationResult | null;
  handoffPackage: AdminEdmHandoffPackage | null;
  policy: AdminEdmPolicy | null;
  loadingArtworks: boolean;
  loadingArtworkDetail: boolean;
  loadingDatasetList: boolean;
  loadingDatasetMeta: boolean;
  loadingDatasetSummary: boolean;
  loadingDatasetBlocked: boolean;
  loadingHandoffPackage: boolean;
  savingArtworkProfile: boolean;
  savingDatasetProfile: boolean;
  runningArtworkTransition: boolean;
  runningArtworkRecompute: boolean;
  runningDatasetRecompute: boolean;
  runningArtworkValidation: boolean;
  runningDatasetValidation: boolean;
  error: string | null;
  datasetListError: string | null;
  datasetMetaError: string | null;
  datasetSummaryError: string | null;
  datasetBlockedError: string | null;
  datasetValidationError: string | null;
  handoffPackageError: string | null;
  artworksError: string | null;
  artworkDetailError: string | null;
  artworkValidationError: string | null;
  artworkTransitionError: string | null;
  artworkSaveError: string | null;
  artworkSaveErrorDetails: AdminEdmArtworkSaveErrorDetails | null;
}

const initialState: AdminEdmState = {
  datasets: [],
  datasetsTotal: 0,
  artworks: [],
  artworksTotal: 0,
  artworksPage: 1,
  artworksLimit: 25,
  artworkDetail: null,
  activeDataset: null,
  datasetSummary: null,
  datasetBlockedRecords: [],
  artworkValidation: null,
  datasetValidation: null,
  handoffPackage: null,
  policy: null,
  loadingArtworks: false,
  loadingArtworkDetail: false,
  loadingDatasetList: false,
  loadingDatasetMeta: false,
  loadingDatasetSummary: false,
  loadingDatasetBlocked: false,
  loadingHandoffPackage: false,
  savingArtworkProfile: false,
  savingDatasetProfile: false,
  runningArtworkTransition: false,
  runningArtworkRecompute: false,
  runningDatasetRecompute: false,
  runningArtworkValidation: false,
  runningDatasetValidation: false,
  error: null,
  datasetListError: null,
  datasetMetaError: null,
  datasetSummaryError: null,
  datasetBlockedError: null,
  datasetValidationError: null,
  handoffPackageError: null,
  artworksError: null,
  artworkDetailError: null,
  artworkValidationError: null,
  artworkTransitionError: null,
  artworkSaveError: null,
  artworkSaveErrorDetails: null,
};

export function adminEdmReducer(state = initialState, action: { type: string; payload: any }) {
  switch (action.type) {
    case GET_EDM_DATASETS:
      return { ...state, loadingDatasetList: true, error: null, datasetListError: null };
    case GET_EDM_DATASETS_SUCCESS:
      {
        const normalized = normalizeAdminEdmDatasetListResponse(action.payload);
      return {
        ...state,
        loadingDatasetList: false,
        datasets: normalized.items,
        datasetsTotal: normalized.total,
      };
      }
    case GET_EDM_DATASETS_FAILED:
      return { ...state, loadingDatasetList: false, error: action.payload, datasetListError: action.payload };

    case CREATE_EDM_DATASET:
    case UPDATE_EDM_DATASET:
      return { ...state, savingDatasetProfile: true, error: null, datasetMetaError: null };
    case CREATE_EDM_DATASET_SUCCESS:
      {
        const normalized = normalizeAdminEdmDatasetDetail(action.payload);
      return {
        ...state,
        savingDatasetProfile: false,
        activeDataset: normalized,
      };
      }
    case UPDATE_EDM_DATASET_SUCCESS:
      {
        const normalized = normalizeAdminEdmDatasetDetail(action.payload);
      return {
        ...state,
        savingDatasetProfile: false,
        activeDataset: normalized,
      };
      }
    case CREATE_EDM_DATASET_FAILED:
    case UPDATE_EDM_DATASET_FAILED:
      return { ...state, savingDatasetProfile: false, error: action.payload, datasetMetaError: action.payload };

    case GET_EDM_DATASET:
      return {
        ...state,
        loadingDatasetMeta: true,
        activeDataset: null,
        datasetSummary: null,
        datasetBlockedRecords: [],
        datasetValidation: null,
        handoffPackage: null,
        error: null,
        datasetMetaError: null,
      };
    case GET_EDM_DATASET_SUCCESS:
      return { ...state, loadingDatasetMeta: false, activeDataset: normalizeAdminEdmDatasetDetail(action.payload) };
    case GET_EDM_DATASET_FAILED:
      return { ...state, loadingDatasetMeta: false, error: action.payload, datasetMetaError: action.payload };

    case GET_EDM_DATASET_SUMMARY:
      return { ...state, loadingDatasetSummary: true, datasetSummaryError: null };
    case GET_EDM_DATASET_SUMMARY_SUCCESS:
      return { ...state, loadingDatasetSummary: false, datasetSummary: normalizeAdminEdmDatasetSummary(action.payload) };
    case GET_EDM_DATASET_SUMMARY_FAILED:
      return { ...state, loadingDatasetSummary: false, datasetSummaryError: action.payload };

    case GET_EDM_DATASET_BLOCKED:
      return { ...state, loadingDatasetBlocked: true, datasetBlockedError: null };
    case GET_EDM_DATASET_BLOCKED_SUCCESS:
      return { ...state, loadingDatasetBlocked: false, datasetBlockedRecords: normalizeAdminEdmBlockedRecords(action.payload) };
    case GET_EDM_DATASET_BLOCKED_FAILED:
      return { ...state, loadingDatasetBlocked: false, datasetBlockedError: action.payload };

    case VALIDATE_EDM_DATASET_MEDIA:
      return { ...state, runningDatasetValidation: true, datasetValidationError: null };
    case VALIDATE_EDM_DATASET_MEDIA_SUCCESS:
      return { ...state, runningDatasetValidation: false, datasetValidation: normalizeAdminEdmDatasetMediaValidation(action.payload) };
    case VALIDATE_EDM_DATASET_MEDIA_FAILED:
      return { ...state, runningDatasetValidation: false, datasetValidationError: action.payload };

    case GET_EDM_DATASET_HANDOFF_PACKAGE:
      return { ...state, loadingHandoffPackage: true, handoffPackageError: null };
    case GET_EDM_DATASET_HANDOFF_PACKAGE_SUCCESS:
      return { ...state, loadingHandoffPackage: false, handoffPackage: normalizeAdminEdmHandoffPackage(action.payload) };
    case GET_EDM_DATASET_HANDOFF_PACKAGE_FAILED:
      return { ...state, loadingHandoffPackage: false, handoffPackageError: action.payload };

    case GET_EDM_POLICY:
      return { ...state, error: null };
    case GET_EDM_POLICY_SUCCESS:
      return { ...state, policy: action.payload };
    case GET_EDM_POLICY_FAILED:
      return { ...state, error: action.payload };

    case RECOMPUTE_EDM_DATASET:
      return { ...state, runningDatasetRecompute: true, datasetMetaError: null };
    case RECOMPUTE_EDM_DATASET_SUCCESS:
      return { ...state, runningDatasetRecompute: false };
    case RECOMPUTE_EDM_DATASET_FAILED:
      return { ...state, runningDatasetRecompute: false, error: action.payload, datasetMetaError: action.payload };

    case GET_EDM_ARTWORKS:
      return { ...state, loadingArtworks: true, artworksError: null };
    case GET_EDM_ARTWORKS_SUCCESS:
      {
        const normalized = normalizeAdminEdmArtworkListResponse(action.payload);
      return {
        ...state,
        loadingArtworks: false,
        artworks: normalized.items,
        artworksTotal: normalized.total,
        artworksPage: normalized.page,
        artworksLimit: normalized.limit,
      };
      }
    case GET_EDM_ARTWORKS_FAILED:
      return { ...state, loadingArtworks: false, artworksError: action.payload };

    case GET_EDM_ARTWORK:
      return {
        ...state,
        loadingArtworkDetail: true,
        artworkDetail: null,
        artworkValidation: null,
        error: null,
        artworkDetailError: null,
      };
    case GET_EDM_ARTWORK_SUCCESS:
      return { ...state, loadingArtworkDetail: false, artworkDetail: normalizeAdminEdmArtworkDetail(action.payload) };
    case GET_EDM_ARTWORK_FAILED:
      return { ...state, loadingArtworkDetail: false, error: action.payload, artworkDetailError: action.payload };

    case UPDATE_EDM_ARTWORK_PROFILE:
      return { ...state, savingArtworkProfile: true, artworkSaveError: null, artworkSaveErrorDetails: null };
    case UPDATE_EDM_ARTWORK_PROFILE_SUCCESS:
      return {
        ...state,
        savingArtworkProfile: false,
        artworkDetail: normalizeAdminEdmArtworkDetail(action.payload),
        artworkSaveError: null,
        artworkSaveErrorDetails: null,
      };
    case UPDATE_EDM_ARTWORK_PROFILE_FAILED:
      return {
        ...state,
        savingArtworkProfile: false,
        error: action.payload?.message || action.payload,
        artworkSaveError: action.payload?.message || action.payload,
        artworkSaveErrorDetails: action.payload?.details || null,
      };

    case RECOMPUTE_EDM_ARTWORK:
      return { ...state, runningArtworkRecompute: true, artworkDetailError: null };
    case RECOMPUTE_EDM_ARTWORK_SUCCESS:
      return { ...state, runningArtworkRecompute: false, artworkDetail: normalizeAdminEdmArtworkDetail(action.payload) };
    case RECOMPUTE_EDM_ARTWORK_FAILED:
      return { ...state, runningArtworkRecompute: false, error: action.payload, artworkDetailError: action.payload };

    case TRANSITION_EDM_ARTWORK:
      return { ...state, runningArtworkTransition: true, artworkTransitionError: null };
    case TRANSITION_EDM_ARTWORK_SUCCESS:
      return { ...state, runningArtworkTransition: false, artworkDetail: normalizeAdminEdmArtworkDetail(action.payload) };
    case TRANSITION_EDM_ARTWORK_FAILED:
      return { ...state, runningArtworkTransition: false, error: action.payload, artworkTransitionError: action.payload };

    case VALIDATE_EDM_ARTWORK_MEDIA:
      return { ...state, runningArtworkValidation: true, artworkValidationError: null };
    case VALIDATE_EDM_ARTWORK_MEDIA_SUCCESS:
      return { ...state, runningArtworkValidation: false, artworkValidation: normalizeAdminEdmArtworkMediaValidation(action.payload) };
    case VALIDATE_EDM_ARTWORK_MEDIA_FAILED:
      return { ...state, runningArtworkValidation: false, artworkValidationError: action.payload };

    default:
      return state;
  }
}
